import React, { useEffect, useRef, useState } from 'react'
import CommonHeroComponent from '../components/CommonHeroComponent/CommonHeroComponent'
import VisionAndMission from '../components/VisionAndMission/VisionAndMission'
import DonationForm from '../components/DonationFormComponent/DonationForm';
import Modal from '../components/Model/Modal';

const QurbaniPage = () => {
  const formRef = useRef(null)
  const [showPlanerPopup, setShowPlanerPopup] = useState(false)
    
      useEffect(()=>{
        setTimeout(()=>{
          setShowPlanerPopup(true)
        },3000)
      },[])

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <div>
       <Modal status={showPlanerPopup} closeModal={()=>{setShowPlanerPopup(false)}}>
          <div className="d-flex flex-column align-items-center justify-content-center py-2 pt-lg-2 pt-5" style={{position:"relative"}}>
            <div className=' w-100 text-center py-4'>
              <h3 className='body-heading ' style={{color:"white"}}>
                Ijtimai Qurbani facility is not available right now, it will be available on the upcoming Eid-ul-Adha.
              </h3>

            </div>
            {/* <h5 style={{color:'white',position:"absolute",top:"0%",right:"10%",cursor:"pointer"}} onClick={()=>{setShowPlanerPopup(false)}}>X</h5> */}
          </div>
        </Modal>
      <CommonHeroComponent
        Heading="Qurbani"
        Para="Join us in our Qurbani services to ensure your sacrifice reaches the needy, providing essential nourishment during Eid."
        backgroundImg="/images/creatives/Qurbani-Hero.jpg"
      />
      
      {/* 
        <div ref={formRef}>
          <DonationForm isQurbaniForm={true} />
        </div>
      */}

      <VisionAndMission heading="About" bluespan=" Qurbani" Para="Qurbani, or the act of sacrifice during Eid al-Adha, commemorates the willingness of Prophet Ibrahim (AS) to sacrifice his son in obedience to Allah. This ritual is a significant act of worship and charity. At Raza Foundation, we ensure your Qurbani reaches those in dire need, providing them with essential nourishment." bluepara="🙶 Take from their money a charity to cleanse them and purify them – Al Qur’an 9:103 🙷"
        image="/images/creatives/Qurbani-One.png"
        background="transparent linear-gradient(313deg, rgba(100, 70, 70, 0) 0%, #FFFFFE00 60%, #A5CD375C 100%, #bbff00 100%) 0% 0% no-repeat" 
        button="noButton"
        serviceId={"qurbani"}
        noBtn={true}
        btnLinkFn={scrollToForm}
        />


      <VisionAndMission flexdirection="row-reverse" heading="How Your Qurbani" bluespan=" Donation Adds Value" Para="By donating Qurbani through Raza Foundation, you fulfill a critical Islamic duty while feeding the poor and hungry. This act of charity strengthens community bonds and spreads the joy of Eid al-Adha. Your Qurbani donation provides meat to those who rarely have access to it, making their celebration special." bluepara="🙶 Take from their money a charity to cleanse them and purify them – Al Qur’an 9:103 🙷"
        image="/images/creatives/Qurbani-Two.png" 
        // button="Book Now"
        serviceId={"qurbani"}
        noBtn={true}
        btnLinkFn={scrollToForm}/>

      <VisionAndMission heading="Ease of Donating" bluespan=" Qurbani and Its Impact" Para="Raza Foundation makes donating Qurbani easy and impactful. Our streamlined process ensures your sacrifice is conducted in accordance with Islamic principles and reaches the needy promptly. Your Qurbani not only supports the less fortunate but also purifies your wealth and brings immense spiritual rewards." bluepara="🙶 Take from their money a charity to cleanse them and purify them – Al Qur’an 9:103 🙷"
        image="/images/creatives/Qurbani-Three.png" 
        // button="Book Now"
        serviceId={"qurbani"}
        noBtn={true}
        btnLinkFn={scrollToForm}/>
    </div>
  );
};

export default QurbaniPage;